module.exports = "/dist/assets/images/apple-touch-icon.png";